module.exports = __webpack_public_path__ + "static/media/zs-gajdosova.e18d61f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/zs-gajdosova.png
// module id = 505
// module chunks = 0